var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_calendar-2",
    "data-name": "vuesax/outline/calendar-2",
    transform: "translate(0 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-2",
    transform: "translate(0 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.969,5.813A.976.976,0,0,1,0,4.844V.969A.976.976,0,0,1,.969,0a.976.976,0,0,1,.969.969V4.844A.976.976,0,0,1,.969,5.813Z",
    transform: "translate(9.365 1.615)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.969,5.813A.976.976,0,0,1,0,4.844V.969A.976.976,0,0,1,.969,0a.976.976,0,0,1,.969.969V4.844A.976.976,0,0,1,.969,5.813Z",
    transform: "translate(19.698 1.615)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M22.927,1.938H.969A.976.976,0,0,1,0,.969.976.976,0,0,1,.969,0H22.927A.976.976,0,0,1,23.9.969.976.976,0,0,1,22.927,1.938Z",
    transform: "translate(3.552 10.772)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M17.76,25.833H7.427C2.713,25.833,0,23.121,0,18.406V7.427C0,2.713,2.713,0,7.427,0H17.76c4.715,0,7.427,2.713,7.427,7.427V18.406C25.188,23.121,22.475,25.833,17.76,25.833ZM7.427,1.938c-3.694,0-5.49,1.8-5.49,5.49V18.406c0,3.694,1.8,5.49,5.49,5.49H17.76c3.694,0,5.49-1.8,5.49-5.49V7.427c0-3.694-1.8-5.49-5.49-5.49Z",
    transform: "translate(2.906 3.552)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M1.292,2.583A1.286,1.286,0,0,1,.8,2.48a1.492,1.492,0,0,1-.426-.271A1.492,1.492,0,0,1,.1,1.783,1.286,1.286,0,0,1,0,1.292,1.358,1.358,0,0,1,.375.375,1.492,1.492,0,0,1,.8.1,1.235,1.235,0,0,1,1.55.026.821.821,0,0,1,1.783.1.978.978,0,0,1,2.015.22l.194.155a2.035,2.035,0,0,1,.155.194A.978.978,0,0,1,2.48.8a.821.821,0,0,1,.077.232,1.751,1.751,0,0,1,.026.258,1.358,1.358,0,0,1-.375.917A1.358,1.358,0,0,1,1.292,2.583Z",
    transform: "translate(9.688 16.146)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M1.292,2.582a1.358,1.358,0,0,1-.917-.375L.22,2.014A.978.978,0,0,1,.1,1.781a.821.821,0,0,1-.077-.232A1.751,1.751,0,0,1,0,1.29,1.286,1.286,0,0,1,.1.8,1.492,1.492,0,0,1,.375.373,1.3,1.3,0,0,1,1.783.1a1.333,1.333,0,0,1,.426.271,1.358,1.358,0,0,1,.375.917,1.751,1.751,0,0,1-.026.258.821.821,0,0,1-.077.232.978.978,0,0,1-.116.232l-.155.194a1.333,1.333,0,0,1-.426.271A1.286,1.286,0,0,1,1.292,2.582Z",
    transform: "translate(14.208 16.147)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.292,2.582a1.286,1.286,0,0,1-.491-.1,1.492,1.492,0,0,1-.426-.271A1.333,1.333,0,0,1,.1,1.781,1.286,1.286,0,0,1,0,1.29,1.358,1.358,0,0,1,.375.373,1.492,1.492,0,0,1,.8.1,1.29,1.29,0,0,1,2.209.373a2.035,2.035,0,0,1,.155.194A.978.978,0,0,1,2.48.8a.779.779,0,0,1,.077.245,1.583,1.583,0,0,1,.026.245,1.358,1.358,0,0,1-.375.917A1.358,1.358,0,0,1,1.292,2.582Z",
    transform: "translate(9.688 20.668)",
    fill: "#c32bd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin9);
export default __webpack_public_path__ + "static/media/spin9.0a13fa6fc79bdc648ab398de99720429.svg";
export { ForwardRef as ReactComponent };